import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

const SkeletonBlock = ({ lines = 5 }) => {
  return (
    <Card className="rounded-md border-0 bg-surface-grouped shadow-primeSm">
      <CardContent className="flex flex-col gap-4 pt-6">
        <Skeleton className="h-[18px] w-[45%]" />
        <div className="flex flex-col gap-3">
          {Array.from({ length: lines }).map((_, i) => (
            <Skeleton key={i} className="h-3 w-full" />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default SkeletonBlock;
